<template>
  <div id="teacher">
    <div class="con_two">
      <div class="tea_l">
        <div class="tea_nav_title">{{showPage.collegeMember}}</div>
        <div class="tea_nav">
          <ul>
            <li style="cursor: pointer;" :class="on[11]" @click="focus(11);selectTitle(11);pushToTeacher();">{{showPage.honoraryProfessor}}</li>
            <li style="cursor: pointer;" :class="on[1]" @click="focus(1);selectTitle(1);pushToTeacher();">{{showPage.professor}}</li>
            <li style="cursor: pointer;" :class="on[2]" @click="focus(2);selectTitle(2);pushToTeacher();">{{showPage.associateProfessor}}</li>
            <li style="cursor: pointer;" :class="on[3]" @click="focus(3);selectTitle(3);pushToTeacher();">{{showPage.assistantProfessor}}</li>
            <!-- <li style="cursor: pointer;" :class="on[4]" @click="focus(4);selectTitle(4);pushToTeacher();">{{showPage.distinguishedProfessor}}</li> -->
            <li style="cursor: pointer;" :class="on[5]" @click="focus(5);selectTitle(5);pushToTeacher();">{{showPage.fullTimeLecturer}}</li>
            <li style="cursor: pointer;" :class="on[6]" @click="focus(6);selectTitle(6);pushToTeacher();">{{showPage.adjunctProfessor}}</li>
            <li style="cursor: pointer;" :class="on[7]" @click="focus(7);selectTitle(7);pushToTeacher();">{{showPage.adjunctAssociateProfessor}}</li>
            <li style="cursor: pointer;" :class="on[8]" @click="focus(8);selectTitle(8);pushToTeacher();">{{showPage.adjunctAssistantProfessor}}</li>
            <li style="cursor: pointer;" :class="on[9]" @click="focus(9);selectTitle(9);pushToTeacher();">{{showPage.adjunctLecture}}</li>
            <li style="cursor: pointer;" :class="on[10]" @click="focus(10);selectTitle(10);pushToTeacher();">{{showPage.teachingAssistant}}</li>
          </ul>
        </div>
      </div>
      <div class="tea_r" v-if="!$route.meta.keepAliveSub">
        <div class="tea_r_l"><span class="con_title con_title_line">{{showTitle()}}</span></div>
        <div class="tea_r_r">
          <input name="" type="text" class="tea_input" :placeholder="showPage.teacherSearch" v-model="searchName">
          <button type="submit" class="tea_btn" @click="search">GO</button>
        </div>
        <div class="fix"></div>
        <div class="mt15">
          <div class="tea_m" v-for="(teacher,index) in teachers" :key="index" v-if="teacher.dept === 1 || teacher.dept === 2">
            {{ returnDept(teacher.dept) }} / <router-link :to="teacherTo(teacher, 0)">{{teacher.nameCh}}</router-link>
          </div>
        </div>
        <!--{{teachers}}-->
        <div class="fix"></div>
        <div class="tea_g">{{showPage.teacherMemberCount}} {{teachers.length}} {{showPage.people}}</div>
        <div class="over_ta">
          <div class="tea_li">
            <div v-for="(teacher,index) in teachers" :key="index" v-if="inCurrentPage(index)">
              <div class="tea_li_l">
                <img :src="teacher.profileImage" v-if="teacher.profileImage">
                <img src="/../static/images/timeline-default-photo.gif" v-else>
              </div>
              <div class="tea_li_r">
                <div class="tea_lititle">{{teacher.nameEn}} {{teacher.nameCh}}</div>
                <div class="tea_tx">{{showTitle()}}</div>
                <div class="tea_tx">{{teacher.office}} / {{teacher.tel}} / {{teacher.email}}</div>
                <div class="tea_tx">Office Hour : {{teacher.advisory}}</div>
                <div class="tea_p">
                  <ul>
                    <li><router-link :to="teacherTo(teacher, 0)">{{showPage.personalInformation}}</router-link></li>
                    <li><router-link :to="teacherTo(teacher, 1)">{{showPage.educationCourses}}</router-link></li>
                    <li><router-link :to="teacherTo(teacher, 2)">{{showPage.awardsExperiences}}</router-link></li>
                    <!--      <li><a @click="pushToInfo(teacher,3)">{{showPage.seminar}}</a></li>
                    <li><a @click="pushToInfo(teacher,4)">{{showPage.journal}}</a></li>
                    <li><a @click="pushToInfo(teacher,5)">{{showPage.book}}</a></li>
                    <li><a @click="pushToInfo(teacher,6)">{{showPage.research}}</a></li> -->
                    <li v-for="(custom,index) in teachercustoms(teacher)" :key="index">
                      <router-link :to="{ name: 'teacher_custom', params: {custom: index,teacherid: teacher.id}}">
                        {{showName(custom)}}
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="fix"></div>
            </div>
          </div>
        </div>
        <div class="pagination-row text-center">
          <Page :current="currentPage" :total="teachers.length" style="margin-top:20px" :page-size="pagesize" @on-change="changePage"></Page>
        </div>
      </div>
      <router-view :teacher="teacher" v-if="$route.meta.keepAliveSub"></router-view>
      <div class="fix"></div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message, ShowPage } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {
  name: 'teacher',
  data() {
    return {
      allTeachers: [],
      teachers: [],
      teacher: '',
      searchName: '',
      currentPage: 1,
      pagesize: 10,
      on: { 1: { on: true } },
      titleIndex: 1,
      showPage: ShowPage(sessionStorage.getItem('locale')),
      customs: [],
    };
  },
  created() {
    this.init();
  },

  methods: {
    init() {
      this.initTeachers();
      this.initCustoms();
    },
    initTeachers() {
      this.getTeachersData();
    },
    getTeachersData() {
      axios.get(API.teacher)
        .then(response => {
          this.allTeachers = response.data.filter(data => {
            return data.trash !== 1;
          });
          this.selectTitle(this.titleIndex);
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    initCustoms() {
      axios.get(API.teacherCustom)
        .then(response => {
          this.customs = response.data;
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    teacherTo(teacher, index) {
      const routename = ['teacher_basic', 'teacher_edu', 'teacher_prize', 'teacher_seminar', 'teacher_journal', 'teacher_book', 'teacher_research']
      const to = { name: routename[index], params: { teacherid: teacher.id } }
      if (sessionStorage.getItem('locale') === 'EN') to.query = { L: 'EN' }
      return to
    },
    returnDept(dept) {
      return dept === 1 ? '體育室主任' : '體育室副主任';
    },
    teachercustoms(teacher) {
      return this.customs.filter(item => {
        return item.teacherId == teacher.id
      })
    },
    search() {
      if (this.searchName) {
        this.teachers = this.teachers.filter(row => {
          return Object.keys(row).some(key => {
            if (key !== 'nameCh' && key !== 'nameEn') return false;
            return String(row[key]).toLowerCase().indexOf(this.searchName) !== -1;
          });
        });
      } else
        this.selectTitle(this.titleIndex);

      this.currentPage = 1;
    },
    changePage(page) {
      this.currentPage = page;
    },
    inCurrentPage(index) {
      let currentPage = this.currentPage,
        pagesize = this.pagesize;
      return (currentPage - 1) * pagesize <= index && index < currentPage * pagesize
    },

    focus(index) {
      this.on = {};
      this.on[index] = { on: true };
    },
    selectTitle(index) {
      this.titleIndex = index;
      this.currentPage = 1;
      this.teachers = this.allTeachers.filter(teacher => {
        return teacher.title == index;
      });
    },
    pushToTeacher() {
      if (this.$route.name !== 'teacher')
        this.$router.push({ name: 'teacher' });
    },

    showTitle() {
      let title = ['', this.showPage.professor, this.showPage.associateProfessor, this.showPage.assistantProfessor,
        this.showPage.distinguishedProfessor, this.showPage.fullTimeLecturer, this.showPage.adjunctProfessor,
        this.showPage.adjunctAssociateProfessor, this.showPage.adjunctAssistantProfessor, this.showPage.adjunctLecture,
        this.showPage.teachingAssistant, this.showPage.honoraryProfessor
      ];
      return title[this.titleIndex];
    },
    showName(custom) {
      let name = { 'CH': custom.nameCh, 'EN': custom.nameEn }
      return name[sessionStorage.locale];
    },


  },
}

</script>
<style lang="scss">


</style>



// WEBPACK FOOTER //
// Teacher.vue?0c662e56